import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftBoxResponse } from '@models/gift';
import dayjs from 'dayjs';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    giftBox: GiftBoxResponse
}

function PurchaseInfo({ giftBox }:Props) {
    const {
        receiverName, giftCoupon, payment,
    } = giftBox;
    const { t } = useTranslation('gift');

    const getCouponStatusKey = (status: string) => {
        const statusMap: Record<string, string> = {
            ISSUED: 'issued',
            USED: 'used',
            CANCELED: 'canceled',
            EXPIRED: 'expired',
            CANCEL_FAILED: 'cancelFailed',
            SENT: 'sent',
            SEND_FAILED: 'sendFailed',
            OFF_USED: 'offUsed',
            DEACTIVATED: 'deactivated',
        };
        return `couponStatus.${statusMap[status] || status.toLowerCase()}`;
    };

    return (
        <Wrapper>
            <Container>
                <Text color={colors.gray6}>{t('giftSent.receiver')}</Text>
                <Text fontWeight='bold' color={colors.gray7}>{receiverName}</Text>
                {giftCoupon && (
                    <Fragment>
                        <Text color={colors.gray6}>{t('giftSent.validPeriod')}</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {dayjs(giftCoupon.startedAt).format('YYYY.MM.DD')}
                            &nbsp;~&nbsp;
                            {dayjs(giftCoupon.expiredAt).format('YYYY.MM.DD')}
                        </Text>
                        <Text color={colors.gray6}>{t('giftSent.couponStatus')}</Text>
                        <Text fontWeight='bold' color={colors.gray7}>
                            {t(getCouponStatusKey(giftCoupon.status))}
                        </Text>
                    </Fragment>
                )}
                <Text color={colors.gray6}>{t('giftSent.paymentMethod')}</Text>
                <Text fontWeight='bold' color={colors.gray7}>
                    {payment.paymentMethod === 'CREDIT_CARD' ? t('giftSent.creditCard') : t('giftSent.prepaidCard')}
                </Text>
                <Text color={colors.gray6}>{t('giftSent.paymentAmount')}</Text>
                <Text fontWeight='bold' color={colors.red}>
                    {payment.amount.toLocaleString()}{t('item.priceUnit')}
                </Text>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 0 20px 32px;
    width: 100%;
`;

const Container = styled.div`
    width: 100%;
    padding: 12px 10px;
    display: grid;
    grid-template-columns: 60px 1fr;
    gap: 6px 0;
    border-radius: 8px;
    background-color: var(--color-gray1);

    & :nth-child(2n) {
        text-align: right;
    }
`;

export default PurchaseInfo;
